(function() {
  function subtleChat() {
    const footerChatLink = document.querySelector('a[href*="#chat"]'); // This will be the trigger to unhide
    if (footerChatLink) {
      footerChatLink.addEventListener('click', handleFooterChatLinkClick);
    }
    function handleFooterChatLinkClick(event) {
      event.preventDefault();
      const shopifyChatContainer = document.querySelector('#shopify-chat');
      if (shopifyChatContainer) {
        shopifyChatContainer.classList.add('show'); // Unhide the chat container with CSS
        const chatToggle = document.querySelector('#ShopifyChat')?.shadowRoot?.querySelector('.chat-toggle');
        chatToggle?.click(); // Open the chat bubble
      }
    }
  }
  document.addEventListener('DOMContentLoaded', subtleChat);
})();